import { Box, Container } from "@mui/material";
import CardServices from '../cardServices';
import { useEffect, useState } from "react";
import api from '../../../services/api';
import RegisterAccess from '../../../utils/registerAccess';
import HeaderGestorConfigs from "../../../utils/headerGestorConfigs";
// import { useSelector } from 'react-redux';


interface MenuState {
  analiseAIM: number;
  aprovadoAIM: number;
  reprovadoAIM: number;
  suspensoAIM: number;
  canceladoAIM: number;
  retiradoAIM: number;
  reclamacoes: number;
}

type MenuProps = {
  styles: string,
  children?: React.ReactNode
}

export default function MenuMedicamentos({ styles, children }: MenuProps) {

  // const user = useSelector(state => state.account.user);
  const [loadMenu, setLoadMenu] = useState<boolean>(true)
  const [menu, setMenu] = useState<MenuState>({
    analiseAIM: 0,
    aprovadoAIM: 0,
    reprovadoAIM: 0,
    suspensoAIM: 0,
    canceladoAIM: 0,
    retiradoAIM: 0,
    reclamacoes: 0,
  })

  useEffect(() => {
    api.get(`/menu/medicamentos`)
      .then(response => {
        setMenu(response.data);
      }).catch(error => {

      }).finally(() => setLoadMenu(false))
  }, [])

  return (
    <Container>
      <RegisterAccess page={'medicamentos'} />

      {/* REGISTO DE MEDICAMENTOS */}
      <br />
      {/* <HeaderGestorConfigs title={'REGISTO DE MEDICAMENTOS'} /> */}
      <Box className={styles}>
        <CardServices load={loadMenu} count={menu.analiseAIM} icone={''} nomeService={'Tabela geral de registo de medicamentos'} link={'/admin/tabela-geral-medicamentos?page=1'} />
        <CardServices load={loadMenu} count={menu.aprovadoAIM} icone={'/icones/Medicamentos_autorizados.svg'} nomeService={'Medicamentos aprovados'} link={'/admin/tabela-geral-medicamentos?page=1&status=Aprovado'} />
        <CardServices load={loadMenu} count={menu.reprovadoAIM} icone={''} nomeService={'Medicamentos reprovados'} link={'/admin/tabela-geral-medicamentos?page=1&status=Reprovado'} />
        <CardServices load={loadMenu} count={menu.suspensoAIM} icone={''} nomeService={'Medicamentos suspensos'} link={'/admin/tabela-geral-medicamentos?page=1&status=Suspenso'} />
        <CardServices load={loadMenu} count={menu.canceladoAIM} icone={''} nomeService={'Medicamentos Cancelados'} link={'/admin/tabela-geral-medicamentos?page=1&status=Cancelado'} />
        <CardServices load={loadMenu} count={menu.retiradoAIM} icone={''} nomeService={'Medicamentos Retirados'} link={'/admin/tabela-geral-medicamentos?page=1&status= Retirado do Mercado'} />
        <CardServices load={loadMenu} count={null} icone={''} nomeService={'Informações / Publicações'} link={'/admin/gestor-site?menu=MEDICAMENTOS'} />
      </Box>


      {/* LISTA NACIONAL DE MEDICAMENTOS ESSENCIAIS */}
      {/* <br />
      <HeaderGestorConfigs title={'LISTA NACIONAL DE MEDICAMENTOS ESSENCIAIS'} />
      <Box className={styles}>
        <CardServices disabled={true} load={loadMenu} count={0} icone={'/icones/Medicamentos_autorizados.svg'} nomeService={'Tabela Geral LNME'} link={'/admin/tabela-Geral'} />
        <CardServices disabled={true} load={loadMenu} count={0} icone={''} nomeService={'Tabela de categorias'} link={'/admin/tabela-categorias'} />
        <CardServices disabled={true} load={loadMenu} count={0} icone={''} nomeService={'Tabela de solicitações'} link={'/admin/solicitacoes'} />
      </Box> */}

      <HeaderGestorConfigs title={'OUTROS SERVIÇOS'} />
      <Box className={styles}>
        {children}

      </Box>
    </Container>
  )
}

